import { useEffect, useMemo, useRef } from 'react';
import { useSelector } from 'react-redux';
import { usePersonasCRUDActions } from '@mm/state/actions/PersonasCRUDActions';
import { selectCurrentUserId } from '@mm/state/selectors/userSelector';
import { StoreState } from '@mm/state/store-interfaces';

export const usePersonas = (remoteFbPageId: string) => {
  const { retrieveMe, retrieve } = usePersonasCRUDActions();
  const personas = useSelector((state: StoreState) => state.personas.entities);
  const personasFetched = useRef<Record<string, boolean>>({});
  const currentUserId = useSelector(selectCurrentUserId);

  useEffect(() => {
    if (remoteFbPageId) {
      retrieveMe(remoteFbPageId);
    }
  }, [remoteFbPageId, retrieveMe]);

  const currentPersona = useMemo(
    () =>
      personas.find(
        p => p.remotePageId === remoteFbPageId && p.userId === currentUserId,
      ) ?? personas.find(p => p.remotePageId === remoteFbPageId),
    [personas, remoteFbPageId, currentUserId],
  );

  const fetchPersona = (personaId: number) => {
    const personasFetchedKey = `${remoteFbPageId}:${personaId}`;
    if (
      personasFetched.current[personasFetchedKey] ||
      personas.find(
        p => p.id === personaId && p.remotePageId === remoteFbPageId,
      )
    ) {
      return;
    }
    personasFetched.current[personasFetchedKey] = true;
    retrieve(remoteFbPageId, personaId);
  };

  return { currentPersona, fetchPersona };
};
